import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import { BANNER_HEIGHT } from 'components/Banner';
import Fade from 'components/Fade';
import { HEADER_HEIGHT } from 'components/TopNavigationHeaderMobile';
import Theme from 'styles/theme';

const TopNavigationDrawerMobile = ({ isTopNavigationOpen, children }) => (
  <div
    id="top-navigation-drawer-mobile"
    className={classnames('TopNavigationDrawerMobile', 'TopNavigationDrawerMobileV1', {
      'TopNavigationDrawerMobileV1--open': isTopNavigationOpen,
    })}
  >
    <Fade show={isTopNavigationOpen}>{children}</Fade>
    <style jsx>
      {`
        .TopNavigationDrawerMobile {
          width: 100%;
          position: absolute;
          z-index: ${Theme.get('z-index-top-navigation')};
          background-color: ${Theme.get('colors-white')};
          overflow-y: auto;
          overflow-x: hidden;
          -webkit-overflow-scrolling: touch;
        }

        .TopNavigationDrawerMobileV1 {
          height: 0;
          transition: height ${Theme.get('transition-duration-fast-ms')} ease-out;
        }

        .TopNavigationDrawerMobileV1--open {
          height: calc(100vh - ${HEADER_HEIGHT}px);
          padding-bottom: ${HEADER_HEIGHT + Theme.get('spacing') * 15}px;
        }
      `}
    </style>
    <style jsx global>
      {`
        .Banner--visible .TopNavigationDrawerMobileV1--open {
          height: calc(100vh - ${HEADER_HEIGHT + BANNER_HEIGHT}px);
        }
      `}
    </style>
  </div>
);

TopNavigationDrawerMobile.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  isTopNavigationOpen: PropTypes.bool.isRequired,
};

TopNavigationDrawerMobile.defaultProps = {
  children: null,
};

export default TopNavigationDrawerMobile;
